<template lang="pug">
b-card.p-10.transit-card
  .container-fluid.m-0
    .row(@click="toggleTransit(transit, !transit.open)" )
      b-col.pl-0.pr-0.article-type.order-2.order-md-1(md="3")
        div.simple-elmnt.mb-0
          <svg v-if="isContainer" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M17.2,24.08c-1.04812,0 -2.02906,0.47031 -2.6875,1.29l-7.2025,9.03h6.45c3.05031,0 5.73781,1.33031 7.6325,3.44h129.1075c1.89469,-2.10969 4.68969,-3.44 7.74,-3.44h6.45l-7.2025,-9.03c-0.645,-0.81969 -1.63937,-1.29 -2.6875,-1.29h-6.88c-1.90812,0 -3.44,1.54531 -3.44,3.44h-116.96c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM3.44,41.28c-1.89469,0 -3.44,1.54531 -3.44,3.44v96.32c0,1.90813 1.54531,3.44 3.44,3.44h10.32c1.89469,0 3.44,-1.53187 3.44,-3.44h137.6c0,1.90813 1.53188,3.44 3.44,3.44h10.32c1.90813,0 3.44,-1.53187 3.44,-3.44v-96.32c0,-1.89469 -1.53187,-3.44 -3.44,-3.44h-10.32c-1.90812,0 -3.44,1.54531 -3.44,3.44h-137.6c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM24.08,58.48c1.89469,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.54531,3.44 -3.44,3.44c-1.89469,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.54531,-3.44 3.44,-3.44zM44.72,58.48c1.89469,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.54531,3.44 -3.44,3.44c-1.89469,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.54531,-3.44 3.44,-3.44zM65.36,58.48c1.89469,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.54531,3.44 -3.44,3.44c-1.89469,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.54531,-3.44 3.44,-3.44zM86,58.48c1.89469,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.54531,3.44 -3.44,3.44c-1.89469,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.54531,-3.44 3.44,-3.44zM106.64,58.48c1.90813,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.53187,3.44 -3.44,3.44c-1.90812,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.53188,-3.44 3.44,-3.44zM127.28,58.48c1.90813,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.53187,3.44 -3.44,3.44c-1.90812,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.53188,-3.44 3.44,-3.44zM147.92,58.48c1.90813,0 3.44,1.54531 3.44,3.44v61.92c0,1.90813 -1.53187,3.44 -3.44,3.44c-1.90812,0 -3.44,-1.53187 -3.44,-3.44v-61.92c0,-1.89469 1.53188,-3.44 3.44,-3.44z"></path></g></g></svg>
          <svg v-if="isParcel" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M21.5,21.5c-3.956,0 -7.16667,3.21067 -7.16667,7.16667v21.5h143.33333v-21.5c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM21.5,64.5v71.66667c0,7.91917 6.41417,14.33333 14.33333,14.33333h100.33333c7.91917,0 14.33333,-6.41417 14.33333,-14.33333v-71.66667zM100.33333,114.66667h28.66667v14.33333h-28.66667z"></path></g></g></svg>
          <svg v-if="isCar" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M150.35667,70.80667l11.25167,-7.525l-7.88333,-11.89667l-13.25833,8.815c-2.00667,-7.10217 -5.0955,-16.86317 -8.54267,-25.39867c-3.26083,-8.09117 -11.18717,-13.30133 -19.909,-13.30133h-52.03c-8.72183,0 -16.64817,5.21017 -19.909,13.30133c-3.44717,8.5355 -6.536,18.2965 -8.54267,25.39867l-13.25833,-8.815l-7.88333,11.89667l11.25167,7.59667c-4.515,2.50833 -7.31,7.16667 -7.31,12.39833v52.89c0,3.956 3.21067,7.16667 7.16667,7.16667h14.33333l-0.07167,-11.46667c10.67833,1.79167 24.725,4.3 50.23833,4.3c25.51333,0 39.56,-2.50833 50.23833,-4.3l-0.07167,11.46667h14.33333c3.94167,0 7.16667,-3.225 7.16667,-7.16667v-52.89c0,-5.23167 -2.795,-9.89 -7.31,-12.47zM53.32,40.27667c1.14667,-2.72333 3.72667,-4.44333 6.665,-4.44333h52.03c2.93833,0 5.51833,1.72 6.665,4.44333c3.225,7.955 6.16333,17.48667 8.09833,24.22333h-81.55667c1.935,-6.73667 4.87333,-16.19667 8.09833,-24.22333zM93.955,98.11167c-4.15667,2.72333 -7.955,9.38833 -7.955,9.38833c0,0 -3.79833,-6.665 -7.955,-9.38833c-4.085,-2.795 -35.045,-4.945 -35.045,-4.945c7.38167,-7.955 43,-7.16667 43,-7.16667c0,0 35.61833,-0.78833 43,7.16667c0,0 -30.96,2.15 -35.045,4.945z"></path></g></g></svg>
          //- i.txt-lg.fa.mr-3.text-gray(:class="isCar ? 'fa-car' : 'fa-box'")
          h6.m-0(style='font-size:16px;') {{ $t(`transit.${transit.type}`) | pluralize(contentTotal) }}
        div.simple-elmnt
          //- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M136.6755,35.3245c-27.98583,-27.98583 -73.36517,-27.98583 -101.351,0c-27.98583,27.98583 -27.98583,73.36517 0,101.351c27.98583,27.98583 73.36517,27.98583 101.351,0c27.98583,-27.98583 27.98583,-73.36517 0,-101.351zM114.66667,107.5h-14.33333v-25.69967l-32.86633,32.86633l-10.13367,-10.13367l32.86633,-32.86633h-25.69967v-14.33333h50.16667z"></path></g></g></svg>
          img.flag-style(
              :src="require(`@/assets/images/countries/${transit.departure.address.country.toLowerCase()}.png`)",
              width="30",
              v-if="transit.departure.address.country"
          )
          img.flag-style(
              :src="require(`@/assets/images/countries/draft.png`)",
              width="30",
              v-if="!transit.departure.address.country"
          )
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#3333336e"><path d="M86,14.33333c-39.517,0 -71.66667,32.14967 -71.66667,71.66667c0,39.517 32.14967,71.66667 71.66667,71.66667c39.517,0 71.66667,-32.14967 71.66667,-71.66667c0,-39.517 -32.14967,-71.66667 -71.66667,-71.66667zM96.44183,114.3585l-10.13367,-10.13367l11.05817,-11.05817h-47.19967v-14.33333h47.19967l-11.05817,-11.05817l10.13367,-10.13367l28.3585,28.3585z"></path></g></g></svg>
          //- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M35.3245,136.6755c27.98583,27.98583 73.36517,27.98583 101.351,0c27.98583,-27.98583 27.98583,-73.36517 0,-101.351c-27.98583,-27.98583 -73.36517,-27.98583 -101.351,0c-27.98583,27.98583 -27.98583,73.36517 0,101.351zM67.467,57.33333l32.86633,32.86633v-25.69967h14.33333v50.16667h-50.16667v-14.33333h25.69967l-32.86633,-32.86633z"></path></g></g></svg>
          //- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill=" #3333335e"><path d="M136.16667,21.5h-100.33333c-7.90483,0 -14.33333,6.4285 -14.33333,14.33333v100.33333c0,7.90483 6.4285,14.33333 14.33333,14.33333h100.33333c7.90483,0 14.33333,-6.4285 14.33333,-14.33333v-100.33333c0,-7.90483 -6.4285,-14.33333 -14.33333,-14.33333zM74.66233,121.80467l-10.13367,-10.13367l25.671,-25.671l-25.62083,-25.62083l10.13367,-10.13367l35.7545,35.7545z"></path></g></g></svg>
          img.flag-style(
              :src="require(`@/assets/images/countries/${transit.arrival.address.country.toLowerCase()}.png`)",
              width="30",
              v-if="transit.arrival.address.country"
          )
          img.flag-style(
              :src="require(`@/assets/images/countries/draft.png`)",
              width="30",
              v-if="!transit.arrival.address.country"
          )
        div.simple-elmnt
          span.date-text {{ $t('transit.createdAt') }} {{ transit.createdAt | moment($i18n.locale) }}
      b-col.order-3.order-md-2(md="5")
        .d-flex.align-items-center.mb-2
          <svg class="icon-st" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M107.5,14.33333c-20.00217,0 -37.2614,11.80081 -45.30957,28.77865c0.774,-0.0215 1.5284,-0.11198 2.30957,-0.11198c4.5795,0 9.04635,0.4964 13.35351,1.41374c6.45717,-9.49583 17.33415,-15.74707 29.64649,-15.74707c19.7585,0 35.83333,16.07483 35.83333,35.83333c0,12.31233 -6.25124,23.18932 -15.74707,29.64649c0.91733,4.30717 1.41374,8.77401 1.41374,13.35351c0,0.78117 -0.09048,1.53557 -0.11198,2.30957c16.97783,-8.04817 28.77865,-25.30741 28.77865,-45.30957c0,-27.65617 -22.5105,-50.16667 -50.16667,-50.16667zM86,50.16667l12.84961,12.84961l-35.83333,35.83333l-12.84961,-12.84961v35.83333h35.83333l-12.84961,-12.84961l35.83333,-35.83333l12.84961,12.84961v-35.83333zM64.5,57.33333c-27.65617,0 -50.16667,22.5105 -50.16667,50.16667c0,27.65617 22.5105,50.16667 50.16667,50.16667c27.65617,0 50.16667,-22.5105 50.16667,-50.16667c0,-5.90533 -1.06861,-11.54337 -2.95345,-16.81087l-11.88379,11.86979c0.22933,1.634 0.5039,3.24975 0.5039,4.94108c0,19.7585 -16.07483,35.83333 -35.83333,35.83333c-19.7585,0 -35.83333,-16.07483 -35.83333,-35.83333c0,-19.7585 16.07483,-35.83333 35.83333,-35.83333c1.69133,0 3.30025,0.27457 4.92708,0.5039l11.88379,-11.88379c-5.2675,-1.88483 -10.9127,-2.95345 -16.81087,-2.95345z"></path></g></g></svg>
          | {{ $t('transit.fromTo', { from: transit.departure.address.country ? country(transit.departure.address.country) : '  ---  ', to: transit.arrival.address.country ? country(transit.arrival.address.country) : '  ---  ' }) }}
          
        .d-flex.align-items-center.mb-2
          <svg class="icon-st" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M43,7.16667v14.33333h-7.16667c-7.88333,0 -14.33333,6.45 -14.33333,14.33333v100.33333c0,7.88333 6.45,14.33333 14.33333,14.33333h100.33333c7.88333,0 14.33333,-6.45 14.33333,-14.33333v-100.33333c0,-7.88333 -6.45,-14.33333 -14.33333,-14.33333h-7.16667v-14.33333h-14.33333v14.33333h-57.33333v-14.33333zM35.83333,57.33333h100.33333v78.83333h-100.33333zM93.16667,93.16667v28.66667h28.66667v-28.66667z"></path></g></g></svg>
          | {{ $t('transit.deliveryAt') }} {{ transit.arrival.date | moment($i18n.locale) }}
        .d-flex.align-items-center.mb-2(v-if="departureAtHome")
          <svg class="icon-st"   xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#333333"><path d="M39.41667,21.5c-21.77233,0 -39.41667,17.64433 -39.41667,39.41667c0,8.42368 2.6671,16.21476 7.16667,22.61979v45.46354h14.33333c0,11.87517 9.62483,21.5 21.5,21.5c11.87517,0 21.5,-9.62483 21.5,-21.5h43c0,11.87517 9.62483,21.5 21.5,21.5c11.87517,0 21.5,-9.62483 21.5,-21.5h14.33333v-35.83333l-19.52636,-39.03874c-1.21117,-2.4295 -3.68064,-3.96126 -6.39682,-3.96126h-24.24349v-14.33333h-44.84766c-7.22918,-8.75117 -18.16251,-14.33333 -30.40234,-14.33333zM39.41667,34.04167c14.82067,0 26.875,12.05433 26.875,26.875c0,14.82067 -12.05433,26.875 -26.875,26.875c-14.82067,0 -26.875,-12.05433 -26.875,-26.875c0,-14.82067 12.05433,-26.875 26.875,-26.875zM39.47266,43.65788l-6.18685,18.68652l12.61165,12.80762l7.65657,-7.5306l-8.00651,-8.13249l4.12923,-12.45768zM114.66667,62.70833h20.91211l15.22917,30.45833h-36.14128zM43,120.04167c4.93783,0 8.95833,4.0205 8.95833,8.95833c0,4.93783 -4.0205,8.95833 -8.95833,8.95833c-4.93783,0 -8.95833,-4.0205 -8.95833,-8.95833c0,-4.93783 4.0205,-8.95833 8.95833,-8.95833zM129,120.04167c4.93783,0 8.95833,4.0205 8.95833,8.95833c0,4.93783 -4.0205,8.95833 -8.95833,8.95833c-4.93783,0 -8.95833,-4.0205 -8.95833,-8.95833c0,-4.93783 4.0205,-8.95833 8.95833,-8.95833z"></path></g></g></svg>
          | {{ $t('transit.pickUpAt') }} {{ transit.departure.date | moment($i18n.locale) }}
      b-col.last-col.order-1.order-md-3(md="4")
        div.last-col-div
          .d-flex.align-items-center.justify-content-md-end.status-st.mb-1.mb-md-2( v-bind:class="{ draft : isDraft, analyzing : (isAnalyzing && !isDraft), declined : (isDeclinedByClient && !isDraft) ,waiting: (isWaitingByClientResponse && !isDraft),'pending-payement' : (isPendingPayement && !isDraft) , win : (hasWin && !isDraft), 't-end' :(isFinish && !isDraft), pending : !isFinish && !isDraft && !isAnalyzing && !isDeclinedByClient && !isWaitingByClientResponse && !hasWin && !isPendingPayement }" v-b-tooltip.hover :title="$t('offer.state.'  + (isDraft ? 'draft' : isAnalyzing ? 'analyzing' : isDeclinedByClient ? 'declined' : isWaitingByClientResponse ? 'waiting' : isPendingPayement ? 'pendingPayement' : hasWin ? 'win'  : isFinish ? 'end' : 'pending') )")
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g :fill="isDraft ? '#333333' : isAnalyzing ? '#a43246' : isDeclinedByClient ? '#d92727' : isWaitingByClientResponse ? '#ff9800' : isPendingPayement ? '#89b7bb' : hasWin ? '#329ca4' : isFinish ? '#146e19' : '#a43246'"><path d="M86,14.33333c-39.517,0 -71.66667,32.14967 -71.66667,71.66667c0,39.517 32.14967,71.66667 71.66667,71.66667c39.517,0 71.66667,-32.14967 71.66667,-71.66667c0,-39.517 -32.14967,-71.66667 -71.66667,-71.66667zM86,114.66667c-15.83117,0 -28.66667,-12.8355 -28.66667,-28.66667c0,-15.83117 12.8355,-28.66667 28.66667,-28.66667c15.83117,0 28.66667,12.8355 28.66667,28.66667c0,15.83117 -12.8355,28.66667 -28.66667,28.66667z"></path></g></g></svg>
            | {{ $t('offer.state.' + (isDraft ? 'draft_sht' : isAnalyzing ? 'analyzing_sht' : isDeclinedByClient ? 'declined_sht' : isWaitingByClientResponse ? 'waiting_sht' : isPendingPayement ? 'panding_p_sht' : hasWin ? 'win_sht' : isFinish ? 'end_sht' : 'pending_sht_c')    ) }} 
          .d-flex.align-items-center.justify-content-md-end
            span.countdown-text2.analyzing-text2.mb-n3.mb-md-2(v-if="(isNew || isAnalyzing) && !isDraft")
              CountDown(:end-date="transit.createdAt")
            span.countdown-text2.declined-text.mb-n3.mb-md-2(v-if="isDeclinedByClient && !isDraft")
              CountDown(:end-date="transit.refuseAt")
        b-button.details-button.d-none.d-md-flex( v-if="!transit.open" @click.stop="toggleTransit(transit, true)") {{ $t('offer.cta.showMore') }}
        
    //- hr
  TransitionExpand
    .container-fluid.m-0(v-if="transit.open")
      b-row( style = "margin-top: 25px")
        b-col
          span.title-row {{ $t('offer.title') }}
      b-row.content-container
        b-col.pl-1.pr-1(md="6" style="flex-direction: column;justify-content: center;")
          Package( :type="transit.type" :contents="transit.contents" )
        b-col(v-if="transit.departure.address.country" style="display: flex; flex-direction: column; justify-content: center;")
          .d-flex.flex-column.align-items-center.flex-fill.justify-content-center.mb-2(v-if="departureAtHarbor")
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M71.66667,14.33333c-7.90483,0 -14.33333,6.4285 -14.33333,14.33333v35.83333c0,7.90483 6.4285,14.33333 14.33333,14.33333h50.16667c7.90483,0 14.33333,-6.4285 14.33333,-14.33333v-35.83333c0,-7.90483 -6.4285,-14.33333 -14.33333,-14.33333zM86,28.66667h21.5v14.33333h-21.5zM147.53256,86c-2.59434,0 -5.18867,0.98945 -7.16667,2.96744l-32.86589,32.86589h-28.66667c-1.978,0 -3.58333,-1.60533 -3.58333,-3.58333c0,-1.978 1.60533,-3.58333 3.58333,-3.58333h14.33333c7.91917,0 14.33333,-6.41417 14.33333,-14.33333v-7.16667h-45.46354c-7.60383,0 -14.89323,3.01627 -20.26823,8.39844l-27.4349,27.4349l28.66667,28.66667l14.33333,-14.33333h51.39844c3.79833,0 7.44661,-1.51172 10.13412,-4.19922l35.83333,-35.83333c3.95599,-3.956 3.956,-10.37733 0,-14.33333c-1.978,-1.97799 -4.57233,-2.96744 -7.16667,-2.96744z"></path></g></g></svg>
            span.px-2 {{ $t('offer.departure.harbor') }}
          .d-flex.flex-column.align-items-center.flex-fill.justify-content-center.mb-2(v-if="!departureAtHarbor")
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M129,0c-15.83117,0 -28.66667,12.8355 -28.66667,28.66667c0,20.47517 28.66667,50.16667 28.66667,50.16667c0,0 28.66667,-29.6915 28.66667,-50.16667c0,-15.83117 -12.8355,-28.66667 -28.66667,-28.66667zM129,18.42057c5.6545,0 10.2461,4.59159 10.2461,10.24609c0,5.6545 -4.5916,10.24609 -10.2461,10.24609c-5.6545,0 -10.2461,-4.59159 -10.2461,-10.24609c0,-5.6545 4.5916,-10.24609 10.2461,-10.24609zM64.29004,21.5c-0.83492,0.02419 -1.66121,0.18857 -2.44954,0.50391l-35.83333,14.33333c-2.71617,1.0965 -4.50716,3.73159 -4.50716,6.66276v100.33333c0,5.06683 5.11767,8.54043 9.82617,6.66276l33.39779,-13.36752l40.50847,13.50749c1.60533,0.5375 3.35042,0.49069 4.92708,-0.13997l35.83333,-14.33333c2.72333,-1.0965 4.50716,-3.7316 4.50716,-6.66276v-53.13411c-4.95933,6.30666 -9.34175,11.01292 -11.19792,12.93359l-10.30208,10.66601l-10.30208,-10.66601c-1.85617,-1.92067 -6.23858,-6.62693 -11.19792,-12.93359v59.75488l-0.22396,0.08399l-42.77604,-14.26335v-85.06217l0.22396,-0.08398l24.34147,8.10449c-1.87767,-5.2675 -3.06543,-10.58741 -3.06543,-15.73307c0,-0.129 0.02799,-0.24893 0.02799,-0.37793l-19.26042,-6.4248c-0.80267,-0.26875 -1.64262,-0.38812 -2.47754,-0.36393z"></path></g></g></svg>
            span.px-2 {{ $t('offer.departure.home') }}
          //- Departure addresses
          .d-flex.flex-column.w-100.align-self-center.mb-2.px-0.px-md-5(style="min-width: 50%")
            h6.mb-2.mt-1.title-adress(
              v-if="departureAtHome"
            ) {{ $t('offer.instructions.departure.home.shipment') }}
            h6.mb-2.mt-1.title-adress(v-else) {{ $t('offer.instructions.departure.harbor.shipment') }}
            .d-flex(v-if="departureAtHome")
              .add-content
                p.m-0 
                  <b>{{ $t('form.address1') | dots($i18n.locale) }}</b> {{ transit.departure.address.address1 ? transit.departure.address.address1 + ', ' : ''}} {{ transit.departure.address.address2 ? transit.departure.address.address2 : '' }}
                p.m-0 
                  <b>{{ $t('form.city') | dots($i18n.locale) }}</b>  {{ transit.departure.address.city }} {{ transit.departure.address.zipCode ? ', ' + transit.departure.address.zipCode  : '' }} 
                p.m-0
                  <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.departure.address.country) }}
                p.m-0
                  <b>{{ $t('offer.instructions.departure.home.departureAt') }}</b> {{ transit.departure.date | moment($i18n.locale) }}
            .d-flex(v-else)
              .add-content
                p.m-0
                  <b>{{ $t('form.city') | dots($i18n.locale) }}</b> {{ transit.departure.address.city }}
                p.m-0
                  <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.departure.address.country) }}
          //- Arrival addresses
          .d-flex.flex-column.w-100.align-self-center.mb-2.px-0.px-md-5(style="min-width: 50%")
            h6.mb-2.mt-1.title-adress {{ $t('offer.instructions.arrival.shipment') }}
            .d-flex
              .add-content
                p.m-0
                  <b>{{ $t('form.city') | dots($i18n.locale) }}</b> {{ transit.arrival.address.city }}
                p.m-0
                  <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.arrival.address.country) }}
                p.m-0(v-if="transit.arrival.date")
                  <b>{{ $t('transit.deliveryAt') }}</b> {{ transit.arrival.date | moment($i18n.locale) }}

      b-row( style = "margin-top: 25px" v-if="(isWaitingByClientResponse || hasWin || isPendingPayement) && transit.replies.length > 0" )
        b-col
          span.title-row {{ $t('offer.proposal.waitings') }}
      b-row.content-container(v-if="isWaitingByClientResponse && transit.replies.length > 0")  
        div.sort-container-2.d-flex.justify-content-center.w-100
          div.d-flex.align-items-center.mb-2.mb-md-3
            <svg class="sort-ico" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="17" height="17" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M35.83333,14.33333l21.5,21.5l21.5,-21.5zM107.5,14.33333l-21.5,21.5h43zM21.5,50.16667v14.33333h7.16667l43,55.27572v37.89095h28.66667v-37.89095l43,-55.27572h7.16667v-14.33333z"></path></g></g></svg>
            span.sort-title {{ $t('offer.proposal.sort.sortBy') }}
          div.d-flex.sort-button.mb-2.mb-md-3(v-for="sortEl in sortList" :key="sortEl" @click="toggleSort(sortEl)" :class="{'selected-sort-2' : sortBy==sortEl}" v-b-tooltip.hover.top :title="$t('offer.proposal.sortHint.'+ sortEl)")
            span {{ $t('offer.proposal.sort.'+ sortEl) }}
            <svg class="sort-ico2" v-if="sortBy==sortEl && sDirect" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
            <svg class="sort-ico2" v-if="sortBy==sortEl && !sDirect" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M28.66667,64.5l57.33333,57.33333l57.33333,-57.33333z"></path></g></g></svg>

        OfferModel(v-for="(reply2, i) in repliesToShow" :transit="transit" :reply2="reply2" :selectedR="selectedReply==i+repliesIndex" :index="i+repliesIndex" :key="'offer' + (i+repliesIndex)" @selected="onSelectChange(i+repliesIndex)")    
        div.pag-container.d-flex.justify-content-center.w-100
          div.pag-el(v-for="index in 4" :key="index" v-if="transit.replies && transit.replies.length>((index-1)*3) && transit.replies.length>3" @click="toggleRepliesPage(index-1)" :class="{'pag-el-active' : repliesIndex == (index-1)}") {{index}}
        //- OfferInstructions( v-for="reply in transit.replies" :key="item.id" :transit="reply" :pending="isWaitingByClientResponse")
          //- h5 {{ isWaitingByClientResponse ? $t('offer.proposal.waiting') : $t('offer.proposal.win') }}
      b-row( style = "margin-top: 25px" v-if="hasWin || isFinish || isPendingPayement" )
        b-col
          span.title-row {{ $t('offer.proposal.payed') }}
      b-row.content-container( v-if="hasWin || isFinish || isPendingPayement" )
        //- OfferPending.mt-5(v-if="isWaitingByClientResponse" :reply="reply" :id="'001'")
        OfferAccepted(v-if="hasWin || isFinish" :reply="reply" :departureAtHarbor="departureAtHarbor" :transit="transit")
        PayementPending(v-if="isPendingPayement" :reply="reply")
  .container-fluid.m-0
    b-row(align-v="center")
      .d-flex.w-100.justify-content-between(:class="transit.open ? 'col-12' : 'col-md-3'" ref="fileUp")
        div
          b-button.detail-button.delete-t-button.mt-4( v-if="transit.open && !hasWin && !isPendingPayement && !isFinish" @click="showModal")
            <svg :style="'margin-right: 2px; margin-top: -4px;margin-left: 4px;'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="del-ico" fill="#ffffff"><path d="M71.66667,14.33333l-7.16667,7.16667h-43v14.33333h129v-14.33333h-43l-7.16667,-7.16667zM31.14421,50.16667l11.15593,94.83236c0.84567,7.224 6.96802,12.66764 14.24935,12.66764h58.91504c7.28133,0 13.39685,-5.45081 14.23535,-12.66764l11.15593,-94.83236zM64.5,64.5h14.33333v71.66667h-7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667zM93.16667,64.5h14.33333v64.5c0,3.956 -3.21067,7.16667 -7.16667,7.16667h-7.16667z"></path></g></g></svg>
            span.d-none.d-md-inline {{ $t('offer.cta.remove') }}
          b-button.detail-button.edit-t-button.mt-4.ml-1( v-if="transit.open && isDraft" @click="editTransit")
            <svg :style="'margin-right: 2px; margin-top: -3px;margin-left: -2px;'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="edit-ico" fill="#ffffff"><path d="M131.96744,14.33333c-1.83376,0 -3.66956,0.69853 -5.06706,2.09961l-12.23372,12.23372l28.66667,28.66667l12.23372,-12.23372c2.80217,-2.80217 2.80217,-7.33911 0,-10.13412l-18.53255,-18.53255c-1.40108,-1.40108 -3.23329,-2.09961 -5.06706,-2.09961zM103.91667,39.41667l-82.41667,82.41667v28.66667h28.66667l82.41667,-82.41667z"></path></g></g></svg>
            span {{ $t('offer.cta.edit') }}
        b-button.details-button.close-button.mt-4( variant="primary" v-if="transit.open"  @click="toggleTransit(transit, false)") {{ $t('offer.cta.close') }}
        Modal(v-show="isModalVisible" @close="closeModal" @validate="removeTransit" :type="'delete'" :text="transit.replies && transit.replies.length > 0 ? 'deleteR' : 'delete'")
</template>

<script>
import TransitMixin from '@/mixins/Transit'
import CountDown from '@/components/ui/CountDown'
import TransitionExpand from '@/components/ui/TransitionExpand'
import OfferModel from './offer/OfferModel'
import OfferPending from './offer/OfferPending'
import OfferAccepted from './offer/OfferAccepted'
import PayementPending from './offer/PayementPending'
import Modal from '@/components/layout/Modal';
import Package from '@/components/layout/Package';
import { Auth } from 'aws-amplify'

export default {
  name: 'TransitClient',
  mixins: [TransitMixin],
  components: {
    CountDown,
    TransitionExpand,
    OfferModel,
    OfferPending,
    PayementPending,
    OfferAccepted,
    Modal,
    Package,
  },
  props: {
    transit: Object,
    status: String
  },
  data() {
    return {
      pages:{
        nbPages : 1,
        cuerentPage : 1,
        pageSize: 3,
        pageData : []
      },
      selectedReply : -1,
      repliesToShow : [],
      repliesIndex : 0,
      sortBy: 'best',
      sDirect: false,
      sortList : ['best','price','departure','arrival'],
      isModalVisible: false,
    }
  },
  mounted() {
    if(this.$router.currentRoute.query.files && this.$router.currentRoute.query.files=='true'){
      let element = this.$refs['fileUp'];
      console.log(element.offsetTop+element.offsetHeight);
      window.scrollTo(0, element.offsetTop);
    }
  },
  methods: {
    editTransit(){
      this.$router.push({
        name: 'clientAddTransit',
        params: {
          transit: this.transit
        }
      });
    },
    toggleSort(sortby){
      switch (sortby) {
        case 'best':
          if(this.sortBy==sortby){
            this.sDirect = !this.sDirect;
          } else {
            this.sortBy=sortby;
            this.sDirect = true;
          }
          if(this.sDirect){
            this.transit.replies.sort((a,b) => (a.calculPonderation.rowSumPondere > b.calculPonderation.rowSumPondere) ? 1 : ((b.calculPonderation.rowSumPondere > a.calculPonderation.rowSumPondere) ? -1 : 0))
            } else {
            this.transit.replies.sort((a,b) => (a.calculPonderation.rowSumPondere < b.calculPonderation.rowSumPondere) ? 1 : ((b.calculPonderation.rowSumPondere < a.calculPonderation.rowSumPondere) ? -1 : 0))
          }
          break;

        case 'price':
          if(this.sortBy==sortby){
            this.sDirect = !this.sDirect;
          } else {
            this.sortBy=sortby;
            this.sDirect = true;
          }
          if(this.sDirect){
            this.transit.replies.sort((a,b) => (a.price.totalWithVccTtc > b.price.totalWithVccTtc) ? 1 : ((b.price.totalWithVccTtc > a.price.totalWithVccTtc) ? -1 : 0))
          } else {
            this.transit.replies.sort((a,b) => (a.price.totalWithVccTtc < b.price.totalWithVccTtc) ? 1 : ((b.price.totalWithVccTtc < a.price.totalWithVccTtc) ? -1 : 0))
          }
          break;

        case 'duration':
          if(this.sortBy==sortby){
            this.sDirect = !this.sDirect;
          } else {
            this.sortBy=sortby;
            this.sDirect = true;
          }
          if(this.sDirect){
            this.transit.replies.sort((a,b) => (a.calculPonderation.dureeTrajet > b.calculPonderation.dureeTrajet) ? 1 : ((b.calculPonderation.dureeTrajet > a.calculPonderation.dureeTrajet) ? -1 : 0))
          } else {
            this.transit.replies.sort((a,b) => (a.calculPonderation.dureeTrajet < b.calculPonderation.dureeTrajet) ? 1 : ((b.calculPonderation.dureeTrajet < a.calculPonderation.dureeTrajet) ? -1 : 0))
          }
          break;

        case 'departure':
          if(this.sortBy==sortby){
            this.sDirect = !this.sDirect;
          } else {
            this.sortBy=sortby;
            this.sDirect = true;
          }
          if(this.sDirect){
            this.transit.replies.sort((a,b) => (a.departure.depositDate > b.departure.depositDate) ? 1 : ((b.departure.depositDate > a.departure.depositDate) ? -1 : 0))
          } else {
            this.transit.replies.sort((a,b) => (a.departure.depositDate < b.departure.depositDate) ? 1 : ((b.departure.depositDate < a.departure.depositDate) ? -1 : 0))
          }
          break;

        case 'arrival':
          if(this.sortBy==sortby){
            this.sDirect = !this.sDirect;
          } else {
            this.sortBy=sortby;
            this.sDirect = true;
          }
          if(this.sDirect){
            this.transit.replies.sort((a,b) => (a.calculPonderation.ecartDateArrivee > b.calculPonderation.ecartDateArrivee) ? 1 : ((b.calculPonderation.ecartDateArrivee > a.calculPonderation.ecartDateArrivee) ? -1 : 0))
          } else {
            this.transit.replies.sort((a,b) => (a.calculPonderation.ecartDateArrivee < b.calculPonderation.ecartDateArrivee) ? 1 : ((b.calculPonderation.ecartDateArrivee < a.calculPonderation.ecartDateArrivee) ? -1 : 0))
          }
          break;
      
        default:
          break;
       
      }
      this.toggleRepliesPage(0);
    },
    toggleRepliesPage(page){
      this.selectedReply=-1;
      const inP=(page*3);
      const outP=inP+3;
      this.repliesToShow = this.transit.replies.slice(inP, outP);
      this.repliesIndex = page;
    },
    toggleTransit (transit, open) {
      if(open){
        this.pages.cuerentPage = 1
        this.paginated()
        this.selectedReply=-1
        this.sDirect = false
        this.toggleSort('best')
      }
      this.$store.dispatch(open ? 'openTransit' : 'closeTransit', transit)
    },
    nextPage(){
      if (this.pages.cuerentPage < this.pages.nbPages) {
        this.pages.cuerentPage++;
        this.paginated()
      }
    },
    preivousPage(){
      if (this.pages.cuerentPage > 1) {
        this.pages.cuerentPage--;
        this.paginated()
      }
    },
    findPage(i){
      this.pages.cuerentPage = i;
      this.paginated()
    },
    paginated() {
      this.pages.nbPages = (this.transit.contents && this.transit.contents.length > this.pages.pageSize) ? Math.ceil(this.transit.contents.length / this.pages.pageSize) : 1;
      this.transit.contents ? this.pages.pageData = this.transit.contents.slice(this.indexStart, this.indexEnd) : this.pages.pageData = [];
    },
    onSelectChange(value){
      this.selectedReply= this.selectedReply==value ? -1 : value ;
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async removeTransit(){
      await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/transit/remove/${this.transit.id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "DELETE",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.closeModal();
          if(data==this.transit.id){
            this.$store.dispatch('fetchClientTransit');
            this.$notify({
              type: "success",
              group: "default",
              title: this.$t("notifications.transit.remove.title"),
              text: this.$t("notifications.transit.remove.success"),
            });
          }else{
            this.$notify({
              type: "error",
              group: "default",
              title: this.$t("error.title.tDelete"),
              text: this.$t("error.code." + (data.code ?  data.code : 'T002')),
              duration: 5000,
            });
          }
        })
        .catch((e) => {
          this.closeModal();
          this.$notify({
            type: "error",
            group: "default",
              title: this.$t("error.title.tDelete"),
              text: this.$t("error.code.T002"),
            duration: 5000,
          });
        });
    }
  },
  computed: {
    isNew () {
      return this.reply && this.reply.status === null && this.transit.replies.length == 0
    },
    isDraft() {
      return this.transit.draft;
    },
    isAnalyzing() {
      return this.reply && this.reply.status === STATUS_ANALYSE;
    },
    isWaitingByClientResponse() {
      return (this.reply && (this.reply.status === STATUS_SELECTED_WAITING_CLIENT || this.reply.status === STATUS_WAITING_CLIENT))
    },
    isDeclinedByClient() {
      return this.reply.replyDeclined
      //return this.reply && this.reply.status === STATUS_CLIENT_DECLINED
    },
    hasWin() {
      return this.reply && this.reply.status === STATUS_WIN
    },
    isPendingPayement(){
      return this.reply && this.reply.status === STATUS_PENDING_PAYMENT
    },
    isLose() {
      return this.reply && this.reply.status === STATUS_LOSE
    },
    isFinish(){
      return this.reply && this.reply.status === STATUS_FINISHED
    },
    indexStart() {
      return (this.pages.cuerentPage - 1) * this.pages.pageSize;
    },
    indexEnd() {
      console.log(this.indexStart);
      console.log(this.indexStart + this.pages.pageSize);
      return this.indexStart + this.pages.pageSize;
    },
    contentTotal() {
      let len = 0;
      this.transit.contents.forEach(element => {
        len = element.amount ? len + element.amount : len + 1;
      });
      return len;
    }
  }
}

// selectionné par le system, en attente du paiment client (Ancien version)
const STATUS_SELECTED_WAITING_CLIENT = 'SELECTED_WAITING_CLIENT';
// Transit terminé
const STATUS_FINISHED = 'FINISHED';
// selectionné par le system, en attente du paiment client
const STATUS_WAITING_CLIENT = 'WAITING_CLIENT';
// selectionné par le client, en attente de validation de paiment
const STATUS_PENDING_PAYMENT = 'PENDING_PAYMENT';
// Non selectionné par le system
const STATUS_LOSE = 'LOSE';
// Selectionné mais refusé par le client
const STATUS_CLIENT_DECLINED = 'CLIENT_DECLINED';
// Gagné et payé par le client
const STATUS_WIN = 'WIN';
// Analyse by system to select the good
const STATUS_ANALYSE = 'ANALYSE';
</script>

<style>
  .article-type{
    text-align: center;
  }
  .flag-style{
    border: 1px solid #3333331f;
    margin: 0 10px;
    height: 20.75px !important;
  }
  .transit-card .card-body{
    padding: 0 !important;
  }
  .simple-elmnt{
    /* border: 1px solid #0000000d; */
    padding: 4px 0;
    border-radius: 5px;
    margin-bottom: 5px;
  }
  .date-text{
    padding: 3px 10px;
    color: #3333336e;
    font-weight: 600;
    border-radius: 13px;
    border: 1px solid #33333324;
    font-size: 12px;
  }
  .icon-st{
    margin-right: 5px;
  }
  .status-st{
    border: 1px solid #a4324633;
    border-radius: 50px;
    width: fit-content;
    font-size: 12px;
    padding: 2px 10px 2px 3px;
    font-weight: 600;
    color: #a43246;
    gap: 3px;
    cursor: pointer;
  }
  @media  (max-width: 576px) { 
    .last-col-div{
      margin-bottom: -11px !important;
    }
    .delete-t-button{
      padding : 6px 15px !important;
    }
    .edit-t-button{
      padding : 6px 20px !important;
    }
  }
  .analyzing{
    border-color: #a4324633 !important;
    color: #a43246 !important;
  }
  .declined{
    border-color: #d9272733 !important;
    color: #d92727 !important;
  }
  .waiting{
    border-color: #ff980033 !important;
    color: #ff9800 !important;
  }
  .t-end{
    border-color: #146e1933 !important;
    color: #146e19 !important;
  }
  .win{
    border-color: #329ca433 !important;
    color: #329ca4 !important;
  }
  .pending-payement{
    border-color: #89b7bb33 !important;
    color: #89b7bb !important;
  }
  .draft{
    border-color: #33333333 !important;
    color: #333333 !important;
  }
  .pending{
    border-color: #a4324633 !important;
    color: #a43246 !important;
  }
  .last-col{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }
  .last-col-div{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .countdown-text2{
    font-size: 12px;
    color: #a43246;
    margin-right: 6px;
    min-width: 140px;
    margin-top: -3px; 
  }
  .analyzing-text2{
    color: #a43246 !important;
  }
  .declined-text{
    color: #d92727;
  }

  .close-button{
    opacity: 1 !important;
    padding: 6px 50px !important;
  }
  .detail-button{
    border-radius: 5px;
    background-color: #a43246;
    color: #ffffff;
    border: 1px solid #a43246;
    font-weight: 600;
    padding: 6px 30px;
    opacity: 1;
  }
  .detail-button:hover{
    background-color: #ffffff;
    color: #a43246;
  }
  .delete-t-button:hover{
    color: #c50e0e !important;
    border-color: #c50e0e !important;
  }
  .edit-t-button:hover{
    color: #a43246 !important;
    border-color: #a43246 !important;
  }
  .delete-t-button:hover .del-ico{
    fill: #c50e0e !important;
  } 
  .edit-t-button:hover .edit-ico{
    fill: #a43246 !important;
  } 
  @media only screen and (min-width: 768px){
    .last-row{
      margin-top: -36px;
    }
  }

  .content-container{
    padding: 30px 10px 15px 10px;
    background-color: white;
    border-radius: 5px;
    border: 2px solid #a4324640;
    /* box-shadow: 0 1px 9px 0 rgb(153 153 153 / 11%) !important; */
    margin-top: -10px;
  }
  .title-row{
    background-color: #a43246;
    color: #ffffff;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 600;
    border: 2px solid #85858512;
  }
  .article-style{
    border: 2px solid #7c7c7c0a !important;
    background-color: #f7f7f745;
    border-radius: 7px !important;
  }
  .pag-el{
    padding: 5px 10px;
    min-width: 34px;
    text-align: center;
    margin: 0 4px;
    border: 1px solid #a43246;
    border-radius: 5px;
    font-size: 15px;
    color: #a43246;
    font-weight: 700;
    cursor: pointer;
  }
  .pag-el:hover{
    background-color: #a432461c;
    color: #a43246;
  }
  .pag-el-active{
    background-color: #a43246;
    color: #ffffff;
  }
  .sort-container-2{
    flex-wrap: wrap;
  }
  .sort-title{
    font-weight: 600;
    color: #a43246;
  }
  .sort-ico{
    margin-top: -5px;
  }
  .sort-ico2{
    margin-right: -4px;
  }
  .sort-button{
    /* min-width: 80px; */
    justify-content: center;
    align-items: center;
    border: 1px solid #a43246;
    border-radius: 22px;
    margin-left: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #a43246;
    cursor: pointer;
    padding: 5px 10px;
  }
  .sort-button-arrow{
    fill: white !important;
  }
  .selected-sort-2{
    color: white;
    background-color: #a43246;
  }
</style>
